import styled from 'styled-components';

export const BreadcrumbWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 21;
  height: 50px;
  padding: 8px 10px;
  margin: 0 5px;
  background: rgb(250 250 250 / 100%);
  border-radius: 8px;
  border: 1px solid rgb(240 240 240 / 100%);

  /* Hide the last breadcrumb separator */
  .ant-breadcrumb .ant-breadcrumb-separator:last-child {
    display: none;
  }

  li {
    display: flex;
    align-items: center;
  }

  .ant-breadcrumb {
    font-size: 15px;
  }

  .ant-breadcrumb-separator {
    font-size: 16px;
    color: rgb(0 0 0 / 45%);
    margin: 0 12px;
  }

  .ant-breadcrumb-link {
    font-size: 15px;

    a {
      color: rgb(0 0 0 / 65%);
      transition: all 0.2s ease;
      display: inline-flex;
      align-items: center;
      padding: 4px 8px;
      border-radius: 6px;

      &:hover {
        color: #1890ff;
        background: rgb(24 144 255 / 8%);
      }
    }
  }
`;
